import { useNavigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { ConfirmDrawer } from "@/components/ConfirmDrawer/ConfirmDrawer";

export function CancelHotelBooking({
  open,
  closeDrawer,
}: {
  open: boolean;
  closeDrawer: () => void;
}) {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <ConfirmDrawer
      open={open}
      onClose={closeDrawer}
      onConfirm={() => {
        navigate({ to: "/" });
      }}
      title={intl.formatMessage({
        defaultMessage: "Cancel hotel booking",
        description: "hotels.cancelBooking",
      })}
      description={intl.formatMessage({
        defaultMessage: "Are you sure you want to cancel booking?",
        description: "hotels.cancelBookingDesc",
      })}
      closeLabel={intl.formatMessage({
        defaultMessage: "Back",
        description: "back",
      })}
      confirmLabel={intl.formatMessage({
        defaultMessage: "Cancel",
        description: "cancel",
      })}
    />
  );
}
